// @flow

import moment from 'moment';

import ApiObject from '../ApiObject';

import DateUtils from '../../utils/DateUtils';

export default class AvailabilityHour extends ApiObject {

  opening: number = 0;

  closing: number = 0;

  getOpeningHourAsDate(): Object {
    return moment(this.opening, DateUtils.MS_FORMAT);
  }

  getClosingHourAsDate(): Object {
    return moment(this.closing, DateUtils.MS_FORMAT);
  }

  isWholeDay(): boolean {
    return this.opening === DateUtils.BEGIN_DAY_TIEMSTAMP
    && this.closing === DateUtils.END_DAY_TIMESTAMP;
  }

  setToWholeDay() {
    this.opening = DateUtils.BEGIN_DAY_TIEMSTAMP;
    this.closing = DateUtils.END_DAY_TIMESTAMP;
  }

  setAvailableOnDay() {
    this.opening = null;
    this.closing = null;
  }

  //
  // format
  //

  getOpeningHour(): number {
    return DateUtils.getHourFromMsHourTimestamp(this.opening);
  }

  getOpeningMinute(): number {
    return DateUtils.getMinuteFromMsHourTimestamp(this.opening);
  }

  getClosingHour(): number {
    return DateUtils.getHourFromMsHourTimestamp(this.closing);
  }

  getClosingMinute(): number {
    return DateUtils.getMinuteFromMsHourTimestamp(this.closing);
  }

  getFormatted(): string {
    return `${this.getOpeningHourAsFormattedDate()} - ${this.getClosingHourAsFormattedDate()}`;
  }

  formatTwoDigits(number: number): string {
    return number > 9 ? `${number}` : `0${number}`;
  }

  getOpeningHourAsFormattedDate(): string {
    return DateUtils.getFormattedHourWithMsHour(this.opening);
  }

  getClosingHourAsFormattedDate(): string {
    return DateUtils.getFormattedHourWithMsHour(this.closing);
  }


  getInterval(minuteInterval: number = 15): Array<number> {
    const hours = [];

    const intervalAsMs = (minuteInterval * DateUtils.MINUTE_AS_MILLISECONDS);

    for (let i = this.opening; i <= this.closing; i += intervalAsMs) {
      hours.push(i);
    }

    return hours;
  }
}
